import React, { useState } from 'react';
import '../styles/Contact.css';
import { Container, Row, Col } from "react-bootstrap";
import { FaInstagram } from "react-icons/fa6";
import { TfiEmail } from "react-icons/tfi";
import { TfiGithub } from "react-icons/tfi";


function ContactForm() {
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("submitting");

    const formData = new FormData(e.target);

    try {
      const res = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      });
      if (!res.ok) throw new Error("Submission failed");
      setStatus("success");
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  if (status === "success") {
    return <p className="success">Message sent!</p>;
  }

  return (
    <div className="contact-page" id="contact">
      <div className="contact-container">
        <div data-aos="zoom-in-up" data-aos-once="true" className="contact-form">
          <div className="contact-head-div text-center mx-auto">
            <h1 id="Contact" className="contact-head">
              Contact<span className="header-color">.</span>
            </h1>
          </div>
          <div className="container">
            <div className="git-cont row">
              <div className="col-12 col-sm-6 half">
                <form name="contact" method="POST" onSubmit={handleSubmit}>
                  {/* Required so Netlify knows which form this is */}
                  <input type="hidden" name="form-name" value="contact" />

                  {/* Honeypot: hidden from humans, bots tend to fill it in */}
                  <p style={{ display: "none" }}>
                    <label>
                      Don’t fill this out: <input name="bot-field" />
                    </label>
                  </p>

                  <label htmlFor="fname"> Name </label>
                  <input type="text" id="fname" name="firstname" placeholder="Your name" required />

                  <label htmlFor="email"> Email Address </label>
                  <input id="email" type="email" name="email" placeholder="Your email" required />

                  <label htmlFor="message"> Message</label>
                  <textarea id="message" name="message" placeholder="Your message..." required />

                  <button type="submit" disabled={status === "submitting"}>
                    {status === "submitting" ? "Sending..." : "Submit"}
                  </button>

                  {status === "error" && (
                    <p className="error">Something went wrong. Please try again.</p>
                  )}
                </form>
              </div>

              <div className="col-12 col-sm-6 half">
                <Container>
                  <Row>
                    <Col md={12} className="contact-social">
                      <ul className="contact-social-links">
                        <li className="social-icons">
                          <a href="https://www.instagram.com/" target="_blank" rel="noreferrer"
                            className="icon-colour contact-social-icons">
                            <FaInstagram />
                          </a>
                        </li>
                        <li className="social-icons">
                          <a href="mailto:vurtualdesignadmin@gmail.com"
                            className="icon-colour contact-social-icons">
                            <TfiEmail />
                          </a>
                        </li>
                              <li className="social-icons">
                          <a href="https://www.github.com/" target="_blank" rel="noreferrer"
                            className="icon-colour contact-social-icons">
                            <TfiGithub />
                          </a>
                        </li>
                      </ul>

                      <svg
                        className="contact-device"
                        viewBox="170 30 1010 830"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <g className="device-group device-phone">
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.00s" }}
                            d="M191.0 145.0 L780.0 46.0 L882.0 452.0 L296.0 590.0 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.05s" }}
                            d="M207.0 155.0 L770.0 60.0 L860.0 390.0 L291.0 517.0 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.40s" }}
                            d="M606.0 230.0 L699.0 196.0 L725.0 306.0 L625.0 311.0 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.45s" }}
                            d="M 652.5 213.0 L 675.0 308.5 M 615.5 270.5 L 712.0 251.0" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.50s" }}
                            d="M 291 495 L 860 372" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.55s" }}
                            d="M 231 190 L 245 187 L 247 199 L 233 202 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.60s" }}
                            d="M 818 330 L 826 328 L 829 344 L 821 346 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.50s" }}
                            d="M 597 500 m -6 0 a 6 6 0 1 0 12 0 a 6 6 0 1 0 -12 0" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.55s" }}
                            d="M 574 462 L 612 453 L 614 472 L 576 481 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.60s" }}
                            d="M352.0 579.0 L852.0 467.0 L852.0 481.0 L352.0 594.0 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.65s" }}
                            d="M308.0 598.0 L352.0 594.0 L886.0 474.0 L886.0 461.0 L1160.0 641.0 L530.0 822.0 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.70s" }}
                            d="M 530 822 L 530 836 L 1157 655 L 1160 641 M 530 836 L 308 612 L 308 598" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.75s" }}
                            d="M 1157 655 L 1150 662 L 540 842 L 530 836" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.90s" }}
                            d="M365.2 602.2 L890.9 483.6 L1005.6 561.8 L458.3 708.4 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "1.00s" }}
                            d="M378.2 604.3 L412.9 596.4 L421.5 605.8 L386.6 613.8 Z M421.2 594.5 L448.8 588.2 L457.5 597.5 L429.8 603.9 Z M457.1 586.3 L484.6 580.1 L493.5 589.1 L465.8 595.5 Z M492.9 578.2 L520.5 571.9 L529.5 580.8 L501.8 587.2 Z M528.8 570.0 L556.3 563.8 L565.5 572.5 L537.8 578.9 Z M564.6 561.9 L592.2 555.6 L601.5 564.2 L573.8 570.6 Z M600.5 553.8 L628.0 547.5 L637.4 555.9 L609.7 562.3 Z M636.3 545.6 L663.9 539.3 L673.4 547.5 L645.7 553.9 Z M672.2 537.5 L699.7 531.2 L709.4 539.2 L681.7 545.6 Z M708.0 529.3 L735.6 523.0 L745.4 530.9 L717.7 537.3 Z M743.9 521.2 L771.4 514.9 L781.4 522.6 L753.7 529.0 Z M779.7 513.0 L807.3 506.7 L817.4 514.3 L789.7 520.7 Z M815.6 504.9 L843.1 498.6 L853.3 505.9 L825.6 512.3 Z M851.4 496.7 L886.2 488.8 L896.5 496.0 L861.6 504.0 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "1.05s" }}
                            d="M390.5 618.2 L417.5 611.9 L429.7 625.3 L402.5 631.8 Z M425.8 610.0 L452.8 603.7 L465.2 616.9 L438.0 623.3 Z M461.1 601.8 L488.2 595.5 L500.7 608.4 L473.5 614.9 Z M496.5 593.5 L523.5 587.3 L536.1 599.9 L509.0 606.4 Z M531.8 585.3 L558.8 579.0 L571.6 591.5 L544.5 597.9 Z M567.1 577.1 L594.1 570.8 L607.1 583.0 L580.0 589.5 Z M602.4 568.9 L629.4 562.6 L642.6 574.5 L615.5 581.0 Z M637.7 560.6 L664.7 554.3 L678.1 566.0 L651.0 572.5 Z M673.0 552.4 L700.0 546.1 L713.6 557.6 L686.5 564.1 Z M708.3 544.2 L735.3 537.9 L749.1 549.1 L722.0 555.6 Z M743.6 536.0 L770.6 529.7 L784.6 540.6 L757.5 547.1 Z M778.9 527.7 L805.9 521.4 L820.1 532.2 L793.0 538.6 Z M814.2 519.5 L841.2 513.2 L855.6 523.7 L828.4 530.2 Z M849.5 511.3 L901.3 499.2 L915.9 509.3 L863.9 521.7 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "1.10s" }}
                            d="M404.6 634.2 L448.5 623.7 L460.7 637.0 L416.6 647.8 Z M456.9 621.7 L483.3 615.3 L495.7 628.4 L469.1 634.9 Z M491.7 613.3 L518.1 607.0 L530.7 619.8 L504.1 626.3 Z M526.5 605.0 L553.0 598.7 L565.7 611.2 L539.1 617.8 Z M561.3 596.7 L587.8 590.3 L600.7 602.7 L574.1 609.2 Z M596.1 588.3 L622.6 582.0 L635.7 594.1 L609.1 600.6 Z M630.9 580.0 L657.4 573.6 L670.7 585.5 L644.1 592.0 Z M665.8 571.6 L692.2 565.3 L705.7 576.9 L679.1 583.4 Z M700.6 563.3 L727.0 557.0 L740.7 568.4 L714.1 574.9 Z M735.4 555.0 L761.8 548.6 L775.7 559.8 L749.1 566.3 Z M770.2 546.6 L796.7 540.3 L810.7 551.2 L784.1 557.7 Z M805.0 538.3 L831.5 531.9 L845.7 542.6 L819.1 549.1 Z M839.8 529.9 L866.3 523.6 L880.7 534.0 L854.1 540.6 Z M874.6 521.6 L918.5 511.1 L933.2 521.2 L889.1 532.0 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "1.15s" }}
                            d="M418.7 650.2 L473.4 636.7 L485.7 649.9 L430.7 663.7 Z M481.8 634.7 L508.4 628.1 L520.9 641.1 L494.1 647.8 Z M516.8 626.0 L543.4 619.5 L556.1 632.2 L529.3 638.9 Z M551.9 617.4 L578.5 610.9 L591.3 623.4 L564.5 630.1 Z M586.9 608.8 L613.5 602.2 L626.5 614.5 L599.7 621.2 Z M621.9 600.2 L648.5 593.6 L661.7 605.7 L635.0 612.4 Z M656.9 591.6 L683.6 585.0 L696.9 596.8 L670.2 603.5 Z M692.0 582.9 L718.6 576.4 L732.1 587.9 L705.4 594.7 Z M727.0 574.3 L753.6 567.8 L767.3 579.1 L740.6 585.8 Z M762.0 565.7 L788.6 559.2 L802.6 570.2 L775.8 577.0 Z M797.1 557.1 L823.7 550.5 L837.8 561.4 L811.0 568.1 Z M832.1 548.5 L858.7 541.9 L873.0 552.5 L846.2 559.3 Z M867.1 539.9 L935.8 523.0 L950.4 533.1 L881.4 550.4 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "1.20s" }}
                            d="M432.8 666.1 L505.4 647.8 L517.8 660.9 L444.8 679.7 Z M513.9 645.7 L540.7 638.9 L553.2 651.8 L526.3 658.7 Z M549.1 636.8 L575.9 630.0 L588.7 642.6 L561.7 649.6 Z M584.4 627.9 L611.2 621.1 L624.1 633.5 L597.2 640.4 Z M619.6 619.0 L646.4 612.2 L659.5 624.4 L632.6 631.3 Z M654.9 610.1 L681.7 603.3 L694.9 615.2 L668.0 622.2 Z M690.1 601.2 L716.9 594.4 L730.4 606.1 L703.4 613.0 Z M725.4 592.3 L752.1 585.5 L765.8 597.0 L738.9 603.9 Z M760.6 583.4 L787.4 576.6 L801.2 587.8 L774.3 594.8 Z M795.8 574.5 L822.6 567.7 L836.6 578.7 L809.7 585.7 Z M831.1 565.6 L857.9 558.9 L872.0 569.6 L845.1 576.5 Z M866.3 556.7 L953.0 534.8 L967.7 544.9 L880.6 567.4 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "1.25s" }}
                            d="M447.0 682.1 L482.8 672.8 L498.5 690.1 L462.5 699.7 Z M491.3 670.6 L520.3 663.1 L536.3 680.1 L507.1 687.8 Z M528.8 660.9 L564.6 651.7 L580.9 668.2 L544.8 677.8 Z M573.1 649.5 L602.1 642.0 L618.6 658.2 L589.4 665.9 Z M610.6 639.8 L793.0 592.6 L810.8 607.2 L627.2 655.9 Z M801.5 590.4 L830.5 582.9 L848.6 597.1 L819.4 604.9 Z M839.0 580.7 L868.0 573.2 L886.3 587.1 L857.1 594.9 Z M876.5 571.0 L902.1 564.3 L920.6 578.0 L894.9 584.8 Z M910.6 562.1 L936.2 555.5 L954.9 568.9 L929.2 575.7 Z M944.7 553.3 L970.3 546.7 L989.3 559.8 L963.5 566.6 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "1.40s" }}
                            d="M644.0 675.0 L855.0 624.0 L923.0 684.0 L732.0 741.0 Z" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "1.45s" }}
                            d="M 816.3 709.8 L 821.8 714.2" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.60s" }}
                            d="M 906 474 m -9 0 a 9 9 0 1 0 18 0 a 9 9 0 1 0 -18 0" />
                          <path className="draw-path" pathLength="1" style={{ animationDelay: "0.65s" }}
                            d="M 330 628 L 343 626 L 349 640 L 336 643 Z M 352 652 L 365 649 L 371 662 L 358 665 Z M 376 676 L 390 673 L 396 686 L 382 690 Z" />
                        </g>
                      </svg>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Contact() {
  return <ContactForm />;
}